import { type ColumnVisibleEvent } from "ag-grid-community"

/**
 * Clears the sort and filter of columns the grid just hid, as removing them from the grid used to:
 * a hidden column would otherwise keep reordering or dropping rows with nothing on screen showing
 * why. Row-group columns keep theirs.
 */
export function clearHiddenColumnSortAndFilter({ api, columns }: ColumnVisibleEvent): void {
  const hidden = (columns ?? []).filter(
    (column) => !column.isVisible() && !column.isRowGroupActive(),
  )
  const sorted = hidden.filter((column) => column.getSort())
  if (sorted.length > 0) {
    api.applyColumnState({
      state: sorted.map((column) => ({ colId: column.getColId(), sort: null })),
    })
  }
  const filtered = hidden.filter((column) => column.isFilterActive())
  if (filtered.length === 0) return
  void Promise.all(filtered.map((column) => api.setColumnFilterModel(column, null))).then(() =>
    api.onFilterChanged(),
  )
}
